import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { useState, useEffect } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { areAllFieldsFilled } from './../../utils/calculationDataValidation'
import runCalculator from '../api/runCalculator'
const calculatorType = 'Kosarka'
const Kosarka = () => {
  const [showInputArea, setShowInputArea] = useState(false)
  const [data, setData] = useState({
    values: {
      odds: ['', '', ''],
      teams: ['', '', '', '', '', ''],
    },
    results: {
      winningChances: ['', ''],
      expectedPoints: ['', '', ''],
      expectedDifference: ['', '', ''],
      expectedResult: ['', '', ''],
      betkoResult: [''],
      teamStrength: {
        home: {
          attack: '',
          defense: '',
        },
        away: {
          attack: '',
          defense: '',
        },
        combined: {
          attack: '',
          defense: '',
        },
        matchup: {
          homeAttack_vs_awayDefense: '',
          homeDefense_vs_awayAttack: '',
        },
      },
    },
  })
  const allFieldsFilled = areAllFieldsFilled(data.values)
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState('')
  //New Functions//
  const clearFields = () => {
    setData({
      values: {
        odds: ['', '', ''],
        teams: ['', '', '', '', '', ''],
      },
      results: {
        winningChances: ['', ''],
        expectedPoints: ['', '', ''],
        expectedDifference: ['', '', ''],
        expectedResult: ['', '', ''],
        betkoResult: [''],
        teamStrength: {
          home: {
            attack: '',
            defense: '',
          },
          away: {
            attack: '',
            defense: '',
          },
          combined: {
            attack: '',
            defense: '',
          },
          matchup: {
            homeAttack_vs_awayDefense: '',
            homeDefense_vs_awayAttack: '',
          },
        },
      },
    })
    setShowInputArea(false)
    setApiError('')
  }
  const handleButtonClick = async () => {
    if (showInputArea) {
      clearFields()
      return
    }

    const ok = await handleCalculate()
    if (!ok) return

    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  useEffect(() => {
    if (allFieldsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allFieldsFilled])

  const handleCalculate = async () => {
    const [
      domacinDao,
      domacinPrimio,
      brojUtakmicaDomacin,
      gostDao,
      gostPrimio,
      brojUtakmicaGost,
    ] = data.values.teams.map(Number)

    const [pobedaDomacina, nereseno, pobedaGosta] = data.values.odds.map(Number)

    const body = {
      oddsHome: pobedaDomacina,
      oddsDraw: nereseno,
      oddsAway: pobedaGosta,
      homeGoalsScored: domacinDao,
      homeGoalsConceded: domacinPrimio,
      homeMatchesPlayed: brojUtakmicaDomacin,
      awayGoalsScored: gostDao,
      awayGoalsConceded: gostPrimio,
      awayMatchesPlayed: brojUtakmicaGost,
    }

    setLoading(true)
    setApiError('')

    try {
      const res = await runCalculator('predictions', 'basketball', body)

      setData((prev) => ({
        ...prev,
        results: {
          winningChances: [
            res.finalHomeWinPct.toFixed(2),
            '',
            res.finalAwayWinPct.toFixed(2),
          ],
          expectedPoints: [
            res.pointsMin.toFixed(2),
            res.pointsAvg.toFixed(2),
            res.pointsMax.toFixed(2),
          ],
          expectedDifference: [
            res.winningMarginMin,
            res.winningMarginAvg,
            res.winningMarginMax,
          ],
          expectedResult: [
            `${res.correctScoreHome1} : ${res.correctScoreAway1}`,
            `${res.correctScoreHome2} : ${res.correctScoreAway2}`,
            `${res.correctScoreHome3} : ${res.correctScoreAway3}`,
          ],
          betkoResult: [res.suggestion.toFixed(2)],
          teamStrength: {
            home: {
              attack: res.homeGoalsScoredAvg.toFixed(2),
              defense: res.homeGoalsConcededAvg.toFixed(2),
            },
            away: {
              attack: res.awayGoalsConcededAvg.toFixed(2),
              defense: res.awayGoalsScoredAvg.toFixed(2),
            },
            combined: {
              attack: res.homeScoredAwayConcededAvg.toFixed(2),
              defense: res.homeConcededAwayScoredAvg.toFixed(2),
            },
            matchup: {
              homeAttack_vs_awayDefense: res.homeAwayScoredAvg.toFixed(2),
              homeDefense_vs_awayAttack: res.homeAwayConcededAvg.toFixed(2),
            },
          },
        },
      }))

      return true
    } catch (err) {
      setApiError('Greška pri obračunu, pokušajte ponovo.')
      return false
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={handleButtonClick} disabled={disabled || loading}>
            {showInputArea
              ? 'Unesi obračunske podatke'
              : loading
              ? 'Obračunavanje...'
              : 'Prikaži rezultate'}
          </button>
        </div>
        {apiError && <div className={classesK.errorMessage}>{apiError}</div>}
        {!showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upiši kvote za ishod utakmice
            </div>
            <OddsCalculator
              data={data.values}
              setData={setData}
              field={'odds'}
              labelPrefix={['KI 1', 'KI X', 'KI 2']}
              type={['number', 'number', 'number']}
              min={['0.1', '0.1', '0.1']}
              step={['0.1', '0.1', '0.1']}
              rows={3}
              setError={setError}
            />
            <div className={classesK.sectionTitle}>
              <span>Upiši br. poena / br. ut. za oba tima</span>
            </div>
            <OddsCalculator
              field={'teams'}
              data={data.values}
              setData={setData}
              labelPrefix={[
                'DOM +  ( dom. dao poena)',
                'DOM -  ( dom. primio poena)',
                'DOM BR. ( dom. odigrao utakmica)',
                'GOST +  ( gost. dao poena)',
                'GOST -  ( gost. primio poena)',
                'GOST BR. ( gost. odigrao utakmica)',
              ]}
              step={['1', '1', '1', '1', '1', '1']}
              min={['0', '0', '0', '0', '0', '0']}
              type={[
                'number',
                'number',
                'number',
                'number',
                'number',
                'number',
              ]}
              style={{ appearance: 'auto' }}
              rows={3}
              setError={setError}
            />
          </>
        )}

        {showInputArea && (
          <div>
            <ResultsSection
              title={'Ishod utakmice'}
              subtitle={'Konačan ishod'}
              results={[
                data.results.winningChances[0]
                  ? `${data.results.winningChances[0]}%`
                  : '-',
                data.results.winningChances[2]
                  ? `${data.results.winningChances[2]}%`
                  : '-',
              ]}
              names={['KI 1', 'KI 2']}
              withPercent
            />
            <div>
              <ResultsSection
                title='Granice broja poena'
                subtitle={'Predlozi predikcija br. poena'}
                results={data.results.expectedPoints}
                names={[
                  'Minimalni očekivani broj poena',
                  'Srednji očekivani broj poena',
                  'Maksimalni očekivani broj poena',
                ]}
              />
            </div>
            <div>
              <ResultsSection
                title={'Pobeda sa razlikom'}
                subtitle={'Pobeda favorizovanog tima sa razlikom'}
                names={[
                  'Minimalna očekivana razlika u poenima',
                  'Srednja očekivana razlika u poenima',
                  'Maksimalni očekivani broj poena',
                ]}
                breakLastItem
                results={
                  Array.isArray(data.results.expectedDifference)
                    ? data.results.expectedDifference
                    : []
                }
              />
            </div>
            <div>
              <ResultsSection
                title={'Tačan rezultat'}
                subtitle={'Opciono mogući tačan rezultat'}
                names={[
                  'Predikcija minimalnog tačnog rezultata',
                  'Predikcija srednjeg tačnog rezultata',
                  'Predikcija maksimalnog tačnog rezultata',
                ]}
                results={
                  Array.isArray(data.results.expectedResult)
                    ? data.results.expectedResult
                    : []
                }
                breakLastItem
              />
            </div>
            <div>
              <ResultsSection
                title={'Betko predlog'}
                subtitle={'Betko predlog za igru na "Plus poene"'}
                names={['+ ( na ut.će biti više od prikazanog br.poena)']}
                results={
                  Array.isArray(data.results.betkoResult)
                    ? data.results.betkoResult
                    : []
                }
              />
            </div>
            <div>
              <ResultsSection
                title={'Snage timova'}
                subtitle={`Snaga domaćina`}
                results={[
                  data.results.teamStrength.home.attack,
                  data.results.teamStrength.home.defense,
                ]}
                withPercent={false}
                names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
              />
              <ResultsSection
                subtitle={`Snaga gosta`}
                results={[
                  data.results.teamStrength.away.attack,
                  data.results.teamStrength.away.defense,
                ]}
                withPercent={false}
                names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
              />
              <ResultsSection
                subtitle={`Snage oba tima zajedno`}
                results={[
                  data.results.teamStrength.combined.attack,
                  data.results.teamStrength.combined.defense,
                ]}
                withPercent={false}
                names={[
                  'SNDG ( snaga napada domaćina i gosta )',
                  'SODG ( snaga odbrane domaćina i gosta )',
                ]}
              />
              <ResultsSection
                subtitle={`Tim proseci odbrana i napada`}
                results={[
                  data.results.teamStrength.matchup.homeAttack_vs_awayDefense,
                  data.results.teamStrength.matchup.homeDefense_vs_awayAttack,
                ]}
                withPercent={false}
                names={[
                  'SND + SOG ( dom. daje/gost prima )',
                  'SND + SOD ( dom. prima/gost daje )',
                ]}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Kosarka
